module.exports = __webpack_public_path__ + "img/cerveza2.de0c9394.png";